import {
	userStatus,
	envConfig,
	EncryptMe
} from '../_helpers';
  
export const settingsService = {
	listCompany,
	createCompany,
	updateCompany
}

async function listCompany(company_uuid) {
	let user = userStatus();

	const requestOptions = {
		method: 'GET',
		headers: {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${user.bearer_token}`,
		'req-language': 'pt_BR'
		}
	}

	const response = await fetch(`${envConfig.MAIN_API_URL}/company/list/${company_uuid}`, requestOptions);
	return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function createCompany(company_uuid, obj) {
	let user = userStatus();

	let encrypted = await EncryptMe(obj);

	const requestOptions = {
		method: 'POST',
		headers: {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${user.bearer_token}`,
		'req-language': 'pt_BR'
		},
		body: JSON.stringify(encrypted)
	}

	const response = await fetch(`${envConfig.MAIN_API_URL}/company/${company_uuid}/step2`, requestOptions);
	return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function updateCompany(company_uuid, obj) {
	let user = userStatus();

	let encrypted = await EncryptMe(obj);

	const requestOptions = {
		method: 'PUT',
		headers: {
		'Content-Type': 'application/json',
		'Authorization': `Bearer ${user.bearer_token}`,
		'req-language': 'pt_BR'
		},
		body: JSON.stringify(encrypted)
	}

	const response = await fetch(`${envConfig.MAIN_API_URL}/company/update/${company_uuid}`, requestOptions);
	return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}